import Icon from '@components/v2/ui/Icon/Icon';
import Menu from '@components/v2/ui/Menu/Menu';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import { ButtonBase } from '@mui/material';
import { ChevronDown } from 'lucide-react';
import LangEnum from '../../../../../lang/LangEnum';
import { ProductDetailsTestIds } from '../../../../../utils/testIds/productDetails.testIds';
import { useTranslation } from '../../../../translation/TranslationContext';
import ColorElement from '../../../colors/ColorElement';
import ColorInfo from '../ColorInfo';
import useProductMediaColorSelector from './hooks/useProductMediaColorSelector';
import { useProductMediaColorSelectorStyles } from './productMediaColorSelector.styles';

const COLOR_ELEMENT_SIZE = 1.75;

const ProductMediaColorSelector = () => {
  const { translate } = useTranslation();
  const { classes } = useProductMediaColorSelectorStyles();

  const {
    isOpen,
    colors,
    anchorElement,
    selectedColor,
    openSelector,
    closeSelector,
    handleSelectColor,
    canSelectMediaColor,
  } = useProductMediaColorSelector();

  if (!canSelectMediaColor) {
    return null;
  }

  return (
    <div className={classes.root} test-id={ProductDetailsTestIds.MEDIA_COLOR_SELECTOR}>
      <ButtonBase
        className={classes.toggle}
        aria-expanded={isOpen}
        aria-label={translate(LangEnum.GLOBAL_COLORS)}
        test-id={ProductDetailsTestIds.MEDIA_COLOR_SELECTOR_TOGGLE}
        onClick={openSelector}
      >
        <ColorElement
          isImage={selectedColor?.isImage}
          hexcode={selectedColor?.hexcode}
          imageUrl={selectedColor?.imageUrl}
          size={COLOR_ELEMENT_SIZE}
        />

        <Icon icon={ChevronDown} size="xs" className={classes.toggleIcon} />
      </ButtonBase>

      <Menu
        open={isOpen}
        anchorEl={anchorElement}
        onClose={closeSelector}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{ paper: { className: classes.options } }}
      >
        {colors.map((color) => (
          <MenuItem
            key={color.productColorId}
            className={classes.option}
            selected={color.productColorId === selectedColor?.productColorId}
            onClick={() => handleSelectColor(color.productColorId)}
          >
            <ColorElement
              isImage={color.isImage}
              hexcode={color.hexcode}
              imageUrl={color.imageUrl}
              size={COLOR_ELEMENT_SIZE}
            />

            <ColorInfo showColorIcon={false} code={color.code} name={color.name} />
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default ProductMediaColorSelector;
